/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Past_YearInputs */

const en_past_year = /** @type {(inputs: Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past Year`)
};

const fr_past_year = /** @type {(inputs: Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Année passée`)
};

const de_past_year = /** @type {(inputs: Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letztes Jahr`)
};

const it_past_year = /** @type {(inputs: Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anno scorso`)
};

const ru_past_year = /** @type {(inputs: Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прошлый год`)
};

const es_past_year = /** @type {(inputs: Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El año pasado`)
};

const zh_cn2_past_year = /** @type {(inputs: Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`过去一年`)
};

const ja_past_year = /** @type {(inputs: Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`過去1年間`)
};

const hi_past_year = /** @type {(inputs: Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछले एक साल`)
};

const pt_pt2_past_year = /** @type {(inputs: Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano passado`)
};

/**
* | output |
* | --- |
* | "Past Year" |
*
* @param {Past_YearInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const past_year = /** @type {((inputs?: Past_YearInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Past_YearInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_past_year(inputs)
	if (locale === "de") return de_past_year(inputs)
	if (locale === "it") return it_past_year(inputs)
	if (locale === "ru") return ru_past_year(inputs)
	if (locale === "es") return es_past_year(inputs)
	if (locale === "zh-CN") return zh_cn2_past_year(inputs)
	if (locale === "ja") return ja_past_year(inputs)
	if (locale === "hi") return hi_past_year(inputs)
	if (locale === "pt-PT") return pt_pt2_past_year(inputs)
	return en_past_year(inputs)
});